import { createMediaStyles } from 'lib/styled-helpers'
import React, { FC } from 'react'
import styled from 'styled-components'

import { getProjectName } from '../../../lib/get-project-name'
import { Button } from '../../../ui/button'

export const Guarantees: FC<{
  id: String
  onButtonCLick: () => void
}> = ({ id, onButtonCLick }) => {
  const handleButtonClick = () => {
    document.dispatchEvent(new CustomEvent('kodix:ecom:warrantyButtonClicked', { detail: { carId: id } }))
    onButtonCLick()
  }

  return (
    <Wrap>
      <Title>Бесплатная гарантия 6 месяцев с покрытием до миллиона рублей</Title>
      {false && (
        <Cost>
          <CostItem>
            <div>Стоимость</div>
            <TextBold>Бесплатно</TextBold>
          </CostItem>
          <CostItem>
            <div>Гарантийное покрытие</div>
            <TextBold>500 тыс. - 1 млн ₽</TextBold>
          </CostItem>
        </Cost>
      )}
      <Subtitle>
        Гарантия защищает владельца автомобиля с пробегом от непредвиденного дорогостоящего ремонта. Если выйдет из
        строя двигатель, турбонагнетатель, коробка передач или электрооборудование, их бесплатно отремонтируют.
      </Subtitle>
      <Button customSize={'4.4rem'} textSize={'1.5rem'} onClick={() => handleButtonClick()}>
        Подробнее
      </Button>
    </Wrap>
  )
}

const Wrap = styled.div`
  ${() =>
    createMediaStyles(() => ({
      phone: `padding: 0 15px; margin-bottom: 48px;`,
      tablet: 'padding: 0; margin-bottom: 53px;'
    }))}
`

const Title = styled.div`
  ${({ theme }) => theme.textStyles.h4};
  ${({ theme }) =>
    getProjectName() === 'avito'
      ? 'font-size:3.2rem; line-height: 40px; font-family: "Manrope",-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto" ,"Helvetica Neue", Arial, sans-serif,  "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"'
      : theme.textStyles.p1};
  font-weight: 800;
  ${({ theme }) =>
    createMediaStyles(() => ({
      phone: `max-width: none; margin-bottom: 10px; font-size: 2.4rem; line-height: normal;`,
      tablet: `max-width: 75%; margin-bottom: ${theme.spacing[4]};`,
      desktop: 'max-width: none; font-size:3.2rem; line-height: 40px;',
      projectors: 'max-width: 75%'
    }))}
`

const Subtitle = styled.div`
  ${({ theme }) =>
    getProjectName() === 'avito'
      ? 'font-size:1.6rem; font-weight: 500; line-height: 24px; font-family: "Manrope",-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto" ,"Helvetica Neue", Arial, sans-serif,  "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"'
      : theme.textStyles.p1};
  max-width: 812px;
  margin-bottom: ${({ theme }) => theme.spacing[4]};
`

const Cost = styled.div`
  ${({ theme }) => theme.textStyles.p2};
  margin-bottom: ${({ theme }) => theme.spacing[7]};
  max-width: 75%;
  ${({ theme }) =>
    createMediaStyles(() => ({
      phone: `max-width: none; display: block; margin-bottom: 16px;`,
      tablet: `max-width: 75%; display: flex;`,
      desktop: 'max-width: none',
      projectors: 'max-width: 75%'
    }))}
`

const CostItem = styled.div`
  margin-right: ${({ theme }) => theme.spacing[7]};
  ${({ theme }) =>
    createMediaStyles(() => ({
      phone: `max-width: none; display: block; margin-bottom: 10px;`,
      tablet: `max-width: 75%; margin-bottom: 0;`,
      desktop: 'max-width: none',
      projectors: 'max-width: 75%'
    }))}
`

const TextBold = styled.div`
  margin-top: ${({ theme }) => theme.spacing[1]};
  font-size: 2rem;
  font-family: 'Manrope', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif,
    'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
  font-weight: 700;
`
